"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateSecurity = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Tags_1 = require("../Tags");
var Size_1 = require("../render/Size");
var PrivateSecurity = (function (_super) {
    __extends(PrivateSecurity, _super);
    function PrivateSecurity() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.PRIVATE_SECURITY,
            cost: 8,
            tags: [Tags_1.Tags.EARTH],
            metadata: {
                cardNumber: 'Pf25',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.text('Opponents may not remove your', Size_1.Size.SMALL, true).br;
                    b.megacredits(1).production(function (pb) { return pb.megacredits(1); }).br;
                }),
            },
        }) || this;
    }
    PrivateSecurity.prototype.play = function () {
        return undefined;
    };
    return PrivateSecurity;
}(Card_1.Card));
exports.PrivateSecurity = PrivateSecurity;
